module.exports = __webpack_public_path__ + "img/SignupBackground.eece2823.png";